import type { RouteLocationNormalized } from 'vue-router';

export const useAccessLog = () => {
  // ユーザビリティを下げるないために非同期処理にしている。
  const postAccessLog = (route: RouteLocationNormalized) => {
    useApiFetch('/access-logs', {
      method: 'POST',
      body: JSON.stringify({
        routeName: route.name,
        url: route.path,
      }),
    });
  };
  return { postAccessLog };
}
